import { Link, useParams } from 'react-router-dom';
import { getActiveSubscribeCampaign } from '../../config/campaigns';
import Header from '../shared/Header';
import NotFoundPage from '../shared/NotFoundPage';

/** Real /:slug/blad route — same page shell (header + hero image) as the form/thank-you page. */
export default function SubscribeErrorPage() {
  const { slug = '' } = useParams<{ slug: string }>();
  const config = getActiveSubscribeCampaign(slug);

  if (!config) {
    return <NotFoundPage />;
  }

  const message = (
    <div className="form-copy">
      <h1>Wystąpił błąd</h1>
      <p>Przepraszamy, prosimy spróbować poźniej.</p>
      <p>
        <Link to={`/${slug}`} className="button button--primary">
          Wróć do formularza
        </Link>
      </p>
    </div>
  );

  const images = (
    <>
      {config.backgroundImage && (
        <img src={config.backgroundImage} className="background-image full-height cover" alt="" />
      )}
      {config.mobileImage && (
        <img src={config.mobileImage} className="background-image-mobile full-height cover" alt="" />
      )}
    </>
  );

  if (config.template === 'form-old-layout') {
    return (
      <>
        <Header />
        <div className="main-container">
          <div className="form-outer-container form-outer-container--message">
            <div className="form-bg">
              <div className="form-container">
                <div className="form-row">{message}</div>
              </div>
            </div>
          </div>
          {images}
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="main-container row-layout-template">
        <div className="form-outer-container form-outer-container--message">
          <div className="form-bg">
            <div className="form-container">
              <div className="form-triangle-decor" />
              <div className="form-row">{message}</div>
            </div>
          </div>
        </div>
        <div className="main-image">{images}</div>
      </div>
    </>
  );
}
